/**
 * Resolves a human-readable name for a placed layout item.
 *
 * Layout `items` JSONB stores only `catalog_id` (an `asset_catalog` UUID) — never the catalog name.
 * So the admin Items card showed raw UUIDs. This resolves the id against the catalog map, preferring
 * the catalog `display_name`, then `name`. Falls back to the user's custom `label`, then the raw
 * `catalog_id` (custom procedural shapes have `catalog_id === null`), then the item `type`.
 */
export interface NamedLayoutItem {
  type: string
  catalog_id: string | null
  label?: string
}

export interface CatalogNameFields {
  display_name: string
  name: string
}

export function catalogItemName(
  item: NamedLayoutItem,
  byId: Map<string, CatalogNameFields>,
): string {
  if (item.catalog_id) {
    const c = byId.get(item.catalog_id)
    if (c) return c.display_name || c.name
  }
  return item.label ?? item.catalog_id ?? item.type
}
